module.exports = __webpack_public_path__ + "img/banner_left.4e086c8a.jpg";